const snackbarTypes = {
  INFO: 'info',
  WARNING: 'warn',
  SUCCESS: 'success',
  ERROR: 'error',
};

export { snackbarTypes };
